// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__35zdc","list":"PatternAutocomplete_list__kJPu5"};